import { BULK_UPLOAD, UPLOAD_BULK_TRANSACTIONS } from "./actionTypes";


const bulkUpload = (formData) => ({
    type: BULK_UPLOAD,
    payload: formData,
    errors: null
});

const uploadBulkTransactions = (formData) => ({
    type: UPLOAD_BULK_TRANSACTIONS,
    payload: formData,
    errors: null
});


export {
    bulkUpload, uploadBulkTransactions
}